import React from 'react';
import './Footer.css';
import { useStoreInfo } from '../../hooks/useApi';
import { StoreInfo } from '../../types';

const Footer: React.FC = () => {
  const { data , loading, error} = useStoreInfo();
  const storeInfo : StoreInfo = data || {
    name: 'חיי קדושה',
    tagline: 'לעילוי נשמת סל ראשון חיים סבח',
    description: 'טליתות ,תפילין ,כיסויים וכלל תשמישי הקדושה במחירים נוחים ואיכות הכי גבוהה בשוק',
    contact: {
      phone: '0508445564',
      email: 'matanlior@gmail.com',
      address: 'תמר 10 או סמטת הורד 2'
    }
  };
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{storeInfo.name}</h3>
            <p className="footer-tagline">{storeInfo.tagline}</p>
            <p className="footer-description">
              {storeInfo.description}
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">קישורים מהירים</h4>
            <ul className="footer-links">
              <li><a href="#home">בית</a></li>
              <li><a href="#books">ספרים</a></li>
              <li><a href="#categories">קטגוריות</a></li>
              <li><a href="#about">אודות</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">פרטי התקשרות</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>{storeInfo.contact.phone}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span>{storeInfo.contact.email}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>{storeInfo.contact.address}</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">רשימת תפוצה</h4>
            <p className="newsletter-text">
              הירשמו לקבלת עדכונים על מוצרים חדשים והצעות מיוחדות.
            </p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="הזינו את כתובת המייל שלכם" 
                className="newsletter-input"
              />
              <button className="btn btn-primary newsletter-btn">
                הירשמו
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2024 {storeInfo.name}. All rights reserved.</p>
            <p className="footer-note">
              "חכמה ובינה יקרים מזהב ומכסף רב."
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

